export { CallCenterStandardDaylightObserved } from './generated/CallCenterStandardDaylightObserved.js';